import { NgModule } from "@angular/core";
import {
  MatButtonModule,
  MatIconModule,
  MatCheckboxModule,
  MatToolbarModule,
  MatAutocompleteModule,
  MatOptionModule,
  MatInputModule,
  MatFormFieldModule,
  MatSliderModule,
  MatCardModule,
  MatDialogModule,
  MatTooltipModule,
  MatSelectModule,
  MatDividerModule,
  MatGridListModule,
  MatDatepickerModule,
  MatRadioModule,
  MatNativeDateModule,
  MatListModule,
  MatLineModule,
  MatSnackBarModule,
  MatMenuModule,
  MatChipsModule,
  MatExpansionModule,
  MatPaginatorModule,
  MatTableModule,
} from "@angular/material";

@NgModule({
  imports: [
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatInputModule,
    MatFormFieldModule,
    MatSliderModule,
    MatCardModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatDividerModule,
    MatGridListModule,
    MatRadioModule,
    MatSelectModule,
    MatListModule,
    MatLineModule,
    MatSnackBarModule,
    MatMenuModule,
    MatChipsModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatTableModule,
  ],
  exports: [
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatSliderModule,
    MatCardModule,
    MatDialogModule,
    MatTooltipModule,
    MatDividerModule,
    MatGridListModule,
    MatRadioModule,
    MatSelectModule,
    MatListModule,
    MatLineModule,
    MatSnackBarModule,
    MatMenuModule,
    MatChipsModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatTableModule,
  ],
})
export class MaterialModule {}



// WEBPACK FOOTER //
// ./src/app/material.module.ts